import thunkMiddleware from 'redux-thunk';
import { createBrowserHistory } from 'history';
import {
  createStore, combineReducers, applyMiddleware, compose,
} from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router';

import AccountReducer from 'reducers/AccountReducer.js';
import InsightsReducer from 'reducers/InsightsReducer.js';
import LibraryReducer from 'reducers/LibraryReducer.js';

import {
  BrandProfileReducer,
  PublisherProfileReducer,
  PartnershipProfileReducer,
  HubProfileReducer,
} from 'reducers/EntityProfileReducers/index.js';

import HomeReducer from 'reducers/HomeReducer.js';
import ContentReducer from 'reducers/ContentReducer.js';

// Filter Stores
import PublishersListReducer from 'reducers/PublishersListReducer.js';
import BrandsListReducer from 'reducers/BrandsListReducer.js';
import CategoriesListReducer from 'reducers/CategoriesListReducer.js';
import KeywordsListReducer from 'reducers/KeywordsListReducer.js';
import HubsListReducer from 'reducers/HubsListReducer.js';

import AdvancedSearchReducer from 'reducers/AdvancedSearchReducer.js';
import SearchFeedReducer from 'reducers/SearchFeedReducer.js';
import SearchPreviewReducer from 'reducers/SearchPreviewReducer.js';

import SettingsReducer from 'reducers/SettingsReducer.js';
import ReportsReducer from 'reducers/ReportsReducer.js';
import ReportRequestReducer from 'reducers/ReportRequestReducer.js';

import NotificationsReducer from 'reducers/NotificationsReducer.js';

const initialState = {};
const reducers = history => combineReducers({
  router: connectRouter(history),
  Account: AccountReducer,
  PublishersList: PublishersListReducer,
  BrandsList: BrandsListReducer,
  CategoriesList: CategoriesListReducer,
  KeywordsList: KeywordsListReducer,
  HubsList: HubsListReducer,
  HubProfile: HubProfileReducer,
  Insights: InsightsReducer,
  Library: LibraryReducer,
  BrandProfile: BrandProfileReducer,
  PublisherProfile: PublisherProfileReducer,
  PartnershipProfile: PartnershipProfileReducer,
  AdvancedSearch: AdvancedSearchReducer,
  SearchFeed: SearchFeedReducer,
  SearchPreview: SearchPreviewReducer,
  Content: ContentReducer,
  Home: HomeReducer,
  Settings: SettingsReducer,
  Reports: ReportsReducer,
  ReportRequest: ReportRequestReducer,
  Notifications: NotificationsReducer,
});

export const history = createBrowserHistory();

// export default createStore(reducers);
// IF YOU HAVE THE REDUX DEVTOOLS EXTENSION USE THIS LINE:
// export default createStore(reducers, window.devToolsExtension && window.devToolsExtension());
let middleware;
if (process.env.NODE_ENV === 'test') middleware = applyMiddleware(thunkMiddleware);
else {
  middleware = compose(
    applyMiddleware(routerMiddleware(history), thunkMiddleware),
    window.devToolsExtension ? window.devToolsExtension() : f => f,
  );
}

export default createStore(reducers(history), initialState, middleware);
